import { isDefaultRovoChat } from '@atlassian/conversation-assistant-utils/default-agent';

export const isSpecialistAgentSelected = (
	selectedAgentId?: string,
	fallbackIsSpecialistPromptInput = false,
): boolean => {
	const normalizedAgentId = selectedAgentId?.trim();
	if (normalizedAgentId) {
		return !isDefaultRovoChat({
			agentId: normalizedAgentId,
			agentNamedId: normalizedAgentId,
		});
	}

	return fallbackIsSpecialistPromptInput;
};
